"use client";

import { createContext, useContext, useMemo, useRef } from "react";

/**
 * @typedef {object} StickBottomContextValue
 * @prop {React.MutableRefObject<HTMLDivElement | null>} containerRef
 */

/** @type {StickBottomContextValue} */
const DEFAULT_VALUES = {
  containerRef: { current: null },
};

const StickyBottomContext = createContext(DEFAULT_VALUES);

/**
 * @typedef {object} Props
 * @prop {React.ReactNode} children
 */
/**
 * @param {Props} props
 */
export function StickyBottomProvider({ children }) {
  const ref = useRef(/** @type {HTMLDivElement | null} */ (null));

  const value = useMemo(() => {
    /** @type {StickBottomContextValue} */
    const value = { containerRef: ref };
    return value;
  }, []);

  return (
    <StickyBottomContext.Provider value={value}>
      {children}
    </StickyBottomContext.Provider>
  );
}

export function useStickyBottom() {
  const value = useContext(StickyBottomContext);
  return value;
}
